import { transparentize } from 'polished';
import styled, { css } from 'styled-components';
import { hover } from 'src/components/utils';

export type SaveRibbonButtonVariant = 'overlay' | 'inline';

export const Button = styled.button<{ $variant: SaveRibbonButtonVariant; $isSaved: boolean }>(
  ({ theme, $variant, $isSaved }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    padding: ${theme.sz.s2};
    border: none;
    border-radius: ${theme.bo.round};
    font-size: ${theme.sz.s5};
    cursor: pointer;

    ${
      $variant === 'overlay'
        ? css`
            background-color: ${
              $isSaved ? theme.co.primary20 : transparentize(0.4, theme.co.neutral10)
            };
            color: ${$isSaved ? theme.co.neutral10 : theme.co.neutral99};

            &:hover {
              background-color: ${$isSaved ? hover(theme.co.primary20) : theme.co.neutral10};
            }
          `
        : css`
            background-color: transparent;
            color: ${$isSaved ? theme.co.primary0 : theme.co.neutral10};
            font-size: ${theme.sz.s6};

            &:hover {
              background-color: ${hover(theme.co.neutral98)};
            }
          `
    }

    ${theme.focusVisible};
  `,
);
